import React, { useContext, useMemo } from 'react'
import AccTree from '../AccTree/AccTree'
import { UserContext } from '../../context/UserContext'

const SideTreeMenu = ({ versionName, onIdSelected, versionArray }) => {
  const { user, subscription, areCorrectCredentials } = useContext(UserContext)

  const visibleTree = useMemo(() => {
    if (user?.isPremium) return true
    if (subscription?.length > 0) {
      return subscription.some(
        (sub) => sub.status === 'active' || sub.status === 'trialing'
      )
    }
    return false
  }, [user, subscription])

  return (
    <div
      style={{
        minWidth: 'fit-content',
        width: '100%',
      }}
    >
      {!areCorrectCredentials && (
        <p style={{ textAlign: 'center', marginTop: '1rem', color: 'red' }}>
          El usuario logueado de la aplicación debe de coincidir con el de
          Autodesk.
        </p>
      )}

      {!visibleTree && (
        <p style={{ textAlign: 'center' }}>
          Suscríbete a la versión PRO para poder visualizar el contenido
        </p>
      )}

      {
        <AccTree
          versionName={versionName}
          versionArray={versionArray}
          onIdSelected={onIdSelected}
          visibleTree={visibleTree}
          isCorrectUser={areCorrectCredentials}
        />
      }
    </div>
  )
}

export default SideTreeMenu
